import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CANCEL_LABEL, OK_LABEL } from '@common/constants';
import { IConfirmationDialogData } from 'src/app/core/models/dialog.model';
import { CBXDialogData } from '../../services/dialog/dialog.service';
import { Data } from 'src/app/DataService';
import { PreLoginService } from "src/app/pre-login/pre-login.service";

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  okLabel:string = "";
  cancelLabel:string = "";
  title:string = "";
  message:string = "";
  iscobStatus: boolean;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>, 
    private _dataStore: Data,
    private __preLoginService: PreLoginService,
    @Inject(MAT_DIALOG_DATA) protected data: CBXDialogData
  ) { }

  ngOnInit(): void {
    this.iscobStatus= this.__preLoginService.isCOB;
    this.okLabel = this.data.button[0] ? this.data.button[0] : OK_LABEL;
    this.cancelLabel = this.data.button[1] ? this.data.button[1] : CANCEL_LABEL;
    this.title = this.data.title;
    this.message = this.data.message;
  }

  shareInfo(data) {
    this._dataStore.shareInfo(data, "reference number copied on clipboard!");
  }

  ok(){
    this.dialogRef.close(1);
  }

  cancel(){
    this.dialogRef.close();
  }

}
